export const getApiUrl = (endpoint = '') => {
    const isLocalhost = Boolean(
        window.location.hostname === 'localhost' ||
        window.location.hostname === '[::1]' ||
        window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
    );

    const base = isLocalhost
        ? (process.env.REACT_APP_API_URL || 'http://localhost:5000')
        : window.location.origin;

    return `${base}${endpoint}`;
};
